<template>
    <div class="map_legend2" style="display: block;">
        <!-- 범례닫기 -->
        <div class="map_legend2_close pc-visible"><a href="#" title="범례닫기">닫기</a></div>
        <!-- 범례선택메뉴 -->
        <div class="legend_menu">
            <div class="menu01 on">
                <a href="#" @click.prevent="dummy">{{ selectedTopTab.name }} / {{ selectedMidTab.name }}</a>
            </div>
            <div class="menu01_s on menu_date">
                <span class="date">{{ baseDay }}</span>
                <span class="time">
                    &nbsp;&nbsp;
                    <label for="time"></label>
                    <select v-show="selectedTopTab.code === 'local' || selectedTopTab.code === 'foreigner'"
                        ref="lifePopulationHourSelect"
                        @change="changeLifePopulationHourHandler" id="time">
                        <option value="00" :selected="lifePopulationHour === '00'">00시</option>
                        <option value="03" :selected="lifePopulationHour === '03'">03시</option>
                        <option value="12" :selected="lifePopulationHour === '12'">12시</option>
                        <option value="14" :selected="lifePopulationHour === '14'">14시</option>
                        <option value="19" :selected="lifePopulationHour === '09'">19시</option>
                        <option value="22" :selected="lifePopulationHour === '22'">22시</option>
                    </select>
                    기준
                </span>
            </div>
        </div>

        <!-- 범례리스트 -->
        <div class="legend_list">
            <!-- 총인구 -->
            <ul class="people01" v-if="selectedMidTab.code === 'totalPop'">
                <li><span>1만</span></li>
                <li><span>2만</span></li>
                <li><span>3만</span></li>
                <li><span>4만</span></li>
                <li><span>5만</span></li>
                <li><span>6만</span></li>
            </ul>

            <!-- 유소년 -->
            <ul class="people01" v-if="selectedMidTab.code === 'youngManPop'">
                <li><span>1천</span></li>
                <li><span>2천8백</span></li>
                <li><span>4천6백</span></li>
                <li><span>6천4백</span></li>
                <li><span>8천2백</span></li>
                <li><span>1만</span></li>
            </ul>

            <!-- 청장년 -->
            <ul class="people01" v-if="selectedMidTab.code === 'adultManPop'">
                <li><span>7천</span></li>
                <li><span>1만5천</span></li>
                <li><span>2만3천</span></li>
                <li><span>3만1천</span></li>
                <li><span>3만9천</span></li>
            </ul>

            <!-- 노인인구 -->
            <ul class="people01" v-if="selectedMidTab.code === 'oldManPop'">
                <li><span>2천</span></li>
                <li><span>4천</span></li>
                <li><span>6천</span></li>
                <li><span>8천</span></li>
            </ul>

            <!-- 장애인인구 -->
            <ul class="people02" v-if="selectedMidTab.code === 'disabledPersonPop'">
                <li><span>5백</span></li>
                <li><span>1천</span></li>
                <li><span>1천5백</span></li>
                <li><span>2천</span></li>
                <li><span>2천5백</span></li>
            </ul>

            <!-- 기초수급자인구 -->
            <ul class="people02" v-if="selectedMidTab.code === 'pensionerPop'">
                <li><span>5백</span></li>
                <li><span>1천</span></li>
                <li><span>1천5백</span></li>
                <li><span>2천</span></li>
            </ul>

            <!-- 총내국인 -->
            <ul class="people03" v-if="selectedMidTab.code === 'totalLocalPop'">
                <li><span>1만</span></li>
                <li><span>2만1천</span></li>
                <li><span>3만2천</span></li>
                <li><span>4만3천</span></li>
                <li><span>5만4천</span></li>
                <li><span>6만5천</span></li>
            </ul>
            <!-- 내국인(0 ~ 9세) -->
            <ul class="people03" v-if="selectedMidTab.code === '0to9LocalPop'">
                <li><span>5백</span></li>
                <li><span>1천7백</span></li>
                <li><span>2천9백</span></li>
                <li><span>4천1백</span></li>
                <li><span>5천3백</span></li>
                <li><span>6천5백</span></li>
            </ul>
            <!-- 내국인(10 ~ 19세) -->
            <ul class="people03" v-if="selectedMidTab.code === '10to19LocalPop'">
                <li><span>1천</span></li>
                <li><span>2천5백</span></li>
                <li><span>4천</span></li>
                <li><span>5천5백</span></li>
                <li><span>7천</span></li>
                <li><span>8천5백</span></li>
            </ul>
            <!-- 내국인(20 ~ 39세) -->
            <ul class="people03" v-if="selectedMidTab.code === '20to39LocalPop'">
                <li><span>3천</span></li>
                <li><span>6천</span></li>
                <li><span>9천</span></li>
                <li><span>1만2천</span></li>
                <li><span>1만5천</span></li>
                <li><span>1만8천</span></li>
            </ul>
            <!-- 내국인(40 ~ 59세) -->
            <ul class="people03" v-if="selectedMidTab.code === '40to59LocalPop'">
                <li><span>2천</span></li>
                <li><span>6천</span></li>
                <li><span>1만</span></li>
                <li><span>1만4천</span></li>
                <li><span>1만8천</span></li>
                <li><span>2만2천</span></li>
            </ul>
            <!-- 내국인(60 ~ 79세) -->
            <ul class="people03" v-if="selectedMidTab.code === '60to79LocalPop'">
                <li><span>2천</span></li>
                <li><span>4천</span></li>
                <li><span>6천</span></li>
                <li><span>8천</span></li>
                <li><span>1만</span></li>
                <li><span>1만2천</span></li>
            </ul>
            <!-- 내국인(80세 이상) -->
            <ul class="people03" v-if="selectedMidTab.code === '80overLocalPop'">
                <li><span>3백</span></li>
                <li><span>8백</span></li>
                <li><span>1천3백</span></li>
                <li><span>1천8백</span></li>
                <li><span>2천3백</span></li>
            </ul>

            <!-- 총외국 -->
            <ul class="people04" v-if="selectedMidTab.code === 'totalForeignerPop'">
                <li><span>100</span></li>
                <li><span>240</span></li>
                <li><span>380</span></li>
                <li><span>520</span></li>
                <li><span>660</span></li>
                <li><span>800</span></li>
            </ul>
            <!-- 단기체류외국인 -->
            <ul class="people04" v-if="selectedMidTab.code === 'stopoverPop'">
                <li><span>0</span></li>
                <li><span>25</span></li>
                <li><span>50</span></li>
                <li><span>75</span></li>
                <li><span>100</span></li>
            </ul>
            <!-- 장기체류외국인 -->
            <ul class="people04" v-if="selectedMidTab.code === 'longStayPop'">
                <li><span>100</span></li>
                <li><span>250</span></li>
                <li><span>400</span></li>
                <li><span>550</span></li>
                <li><span>700</span></li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import gripUtil from "@/lib/grip.util.js";

export default {
    name: 'LifemapLegend',
    props: {
        lifePopulationHour: {
            type: String,
            required: false,
            default: '14',
        },
    },
    computed: {
        ...mapGetters({
            selectedTopTab: 'getSelectedTopTab',
            selectedMidTab: 'getSelectedMidTab',
            hjdPopulationBaseDay: 'getHjdPopulationBaseDay',
            hjdDisaledPopulationBaseDay: 'getHjdDisaledPopulationBaseDay',
            hjdPensionerPopulationBaseDay: 'getHjdPensionerPopulationBaseDay',
            localLifePopulationBaseDay: 'getLocalLifePopulationBaseDay',
            shrotStayPopulationBaseDay: 'getShrotStayPopulationBaseDay',
            longStayPopulationBaseDay: 'getLongStayPopulationBaseDay',
        }),
        baseDay: function() {
            if(this.selectedTopTab.code === 'age') {
                if(this.hjdPopulationBaseDay !== '') {
                    return gripUtil.stringToDate(this.hjdPopulationBaseDay).format("yyyy년 MM월 dd일");
                }
            } else if(this.selectedMidTab.code === 'disabledPersonPop') {
                return gripUtil.stringToDate(this.hjdDisaledPopulationBaseDay + "01").format("yyyy년 MM월");
            } else if(this.selectedMidTab.code === 'pensionerPop') {
                return gripUtil.stringToDate(this.hjdPensionerPopulationBaseDay + "01").format("yyyy년 MM월 dd일");
            } else if(this.selectedTopTab.code === 'local') {
                if(this.localLifePopulationBaseDay !== '') {
                    return gripUtil.stringToDate(this.localLifePopulationBaseDay).format("yyyy년 MM월 dd일");
                }
            } else if(this.selectedMidTab.code === 'stopoverPop') {
                if(this.shrotStayPopulationBaseDay !== '') {
                    return gripUtil.stringToDate(this.shrotStayPopulationBaseDay).format("yyyy년 MM월 dd일");
                }
            } else if(this.selectedMidTab.code === 'totalForeignerPop' || this.selectedMidTab.code === 'longStayPop') {
                if(this.longStayPopulationBaseDay !== '') {
                    return gripUtil.stringToDate(this.longStayPopulationBaseDay).format("yyyy년 MM월 dd일");
                }
            }

            return "";
        }
    },
    methods: {
        dummy() {},
        changeLifePopulationHourHandler() {
            let hour = this.$refs['lifePopulationHourSelect'].value;
            this.$emit("change-life-population-hour", hour);
        }
    }
}
</script>
